import type { DashboardRowType } from '@shared/types/Dashboard';

export const profileGeneralPageDashboardRows: DashboardRowType[] = [
  {
    items: [
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 0,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 6,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 4,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 1,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 3,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 7,
      },
    ],
  },
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 2,
        elementId: 12,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 13,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 9,
      },
    ],
  },
];

export const profileGeneralPageDashboardRowsMobile: DashboardRowType[] = [
  {
    items: [
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 0,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 6,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 4,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 1,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 3,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 7,
      },
    ],
  },
  {
    items: [
      {
        rowSpan: 2,
        colSpan: 2,
        elementId: 12,
      },
      {
        rowSpan: 2,
        colSpan: 2,
        elementId: 13,
      },
      {
        rowSpan: 2,
        colSpan: 2,
        elementId: 9,
      },
    ],
  },
];
